import React from 'react';

type AuroraBackgroundProps = {
  className?: string;
};

/**
 * AuroraBackground
 * Superposition visuelle: dégradés flous animés + grille + bruit léger.
 * Non interactif, fixe derrière le contenu.
 */
const AuroraBackground: React.FC<AuroraBackgroundProps> = ({ className }) => {
  return (
    <div className={`aurora-container ${className ?? ''}`} aria-hidden="true">
      {/* Grille subtile */}
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'linear-gradient(rgba(124,58,237,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(124,58,237,0.06) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} />

      {/* Couches aurora animées - Optimized gradients to be softer without blur filter */}
      {/* Animations disabled for performance */}
      <div className="aurora-layer" style={{
        background: 'radial-gradient(circle at 50% 50%, rgba(124,58,237,0.15) 0%, transparent 60%)'
      }} />
      <div className="aurora-layer" style={{
        background: 'radial-gradient(circle at 70% 30%, rgba(168,85,247,0.15) 0%, transparent 50%), radial-gradient(circle at 30% 70%, rgba(124,58,237,0.15) 0%, transparent 50%)',
      }} />

      {/* Bruit animé très léger */}
      <div className="aurora-noise bg-noise" />
    </div>
  );
};

export default AuroraBackground;


